import { withInstall } from '@zoryn/utils'
import Dialog from './src/dialog.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDialog: SFCWithInstall<typeof Dialog> = withInstall(Dialog)
export default ZDialog

export * from './src/use-dialog'
export * from './src/dialog'
export * from './src/constants'
